import { render } from "./ConfirmationSuccess.vue?vue&type=template&id=5bca2806&scoped=true"
const script = {}

import "./ConfirmationSuccess.vue?vue&type=style&index=0&id=5bca2806&scoped=true&lang=css"

import exportComponent from "/var/www/production/app.labparahita.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bca2806"]])

export default __exports__